import {
  ApiNewDokumentPowiazanyDalDto,
  EgibObject,
  LawPersonAddress,
} from '@gk/gk-modules';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import {
  DocumentationFormType,
  ExtendedInvestorRequest,
  ExtendedInvestorRequestDto,
} from '../../../../../shared/base-new-request/base-new-request.model';
import { InvestorDetails } from '../../../../../shared/investor-details/investor-details.model';
import { Shipping } from '../../../../../shared/shipping-form/shipping-form.model';
import { DateHelperUtil } from '../../../../../utils/date-helper/date-helper.util';

export interface NALUNewRequestDto extends ExtendedInvestorRequestDto {
  DataWylaczenia: string;
}

export class NALUNewRequest extends ExtendedInvestorRequest {
  constructor(
    investorDetails: InvestorDetails,
    proxyDetails: InvestorDetails,
    public idNumber: number,
    public phoneNumber: number,
    public email: string,
    public address: LawPersonAddress,
    proxyDetailsCheckbox: boolean,
    public dateOff: NgbDateStruct,
    public attachments: ApiNewDokumentPowiazanyDalDto,
    documentationForm: DocumentationFormType,
    shippingForm: Shipping,
  ) {
    super(
      investorDetails,
      documentationForm,
      shippingForm,
      undefined,
      proxyDetails,
      proxyDetailsCheckbox,
    );
  }
  static fromAppToApi(
    data: NALUNewRequest,
    parcels: EgibObject[],
    files: ApiNewDokumentPowiazanyDalDto[],
  ): NALUNewRequestDto {
    return {
      ...ExtendedInvestorRequest.mapCommonFields({
        data,
        parcels,
        files,
      }),
      DataWylaczenia: DateHelperUtil.ngbDateToApiDateTime(data.dateOff),
    };
  }
}
